import * as preregisterApplicantsTypes from './preregisterApplicantsTypes';

const initialState = {};

const logsFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case preregisterApplicantsTypes.CLEAR_FILTER:
      return { ...state, ...initialState};

    case preregisterApplicantsTypes.ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    case preregisterApplicantsTypes.ON_CHANGE_DATE:
      return {
        ...state,
        ...action.payload,
      };
    case preregisterApplicantsTypes.GET_FILTERS_SUCCESS:
        return {
            ...state,
            filters: action.payload,
        };
    default:
      return state;
  }
};

export { initialState };
export default logsFilterReducer;



// WEBPACK FOOTER //
// ./src/ui/features/PreregisterApplicants/state/logsFilterReducer.js